const fetch = require('node-fetch');

const {config} = require('../../config');

module.exports = async function sendSlackNotification(message) {
  const body = {
    channel: config.slack.channel,
    attachments: [
      {
        text: message,
        color: '#FF0000',
        type: 'mrkdwn'
      }
    ]
  };

  const result = await fetch(`${config.slack.webhook}`, {
    method: 'post',
    body: JSON.stringify(body),
    headers: {'Content-Type': 'application/json'}
  });

  if (!result.ok) {
    console.log(result);
    throw new Error(`Server error ${result.status}`);
  }
};
